<section
  *ngIf="!isPasswordResetOpen && !isMfaVerificationOpen && !isForcePwdResetOpen"
>
  <div class="flex flex-col items-center justify-center px-6 py-8 mx-auto">
    <div
      class="containerLogin w-[516px] 3xl:w-[645px] 4xl:w-[775px] bg-white rounded-lg md:mt-0 xl:p-0"
    >
      <div class="py-10 px-10 3xl:px-12 space-y-1 md:space-y-6">
        <h1
          class="leading-tight tracking-tight text-dimot-1 text-[1.75em] 3xl:text-[2.15em] 4xl:text-[2.55em] mt-2 3xl:mt-4 4xl:mt-6"
        >
          Accedi al tuo Account
        </h1>
        <form
          class="space-y-4 md:space-y-6"
          [formGroup]="loginForm"
          (ngSubmit)="login()"
        >
          <!-- Email Field with Icon -->
          <div>
            <label
              for="email"
              class="block mb-2 text-[1.15em] 3xl:text-[1.40em] 4xl:text-[1.65em] mt-0 3xl:mt-[20px] 4xl:mt-[40px] text-gray-500"
            >
              Nome Utente
            </label>

            <div class="relative">
              <div
                class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
              >
                <svg
                  class="m-1 w-6 h-6 3xl:w-8 3xl:h-8 4xl:w-10 4xl:h-10 text-gray-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill-rule="evenodd"
                    d="M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4h-4Z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <input
                type="email"
                name="email"
                id="email"
                [formControlName]="'email'"
                class="h-12 3xl:h-14 4xl:h-16 mt-0 3xl:mt-3 4xl:mt-5 text-sm 3xl:text-[1.1em] 4xl:text-[1.3em] pl-13 3xl:pl-15 4xl:pl-17 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-gray-600 focus:border-gray-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 read-only:cursor-not-allowed"
                required=""
                [readOnly]="this.company ? true : false"
              />
            </div>
          </div>

          <!-- Password Field with Icon -->
          <div>
            <label
              for="password"
              class="block mt-0 3xl:mt-4 4xl:mt-8 mb-2 text-[1.15em] 3xl:text-[1.40em] 4xl:text-[1.65em] font-medium text-gray-500 dark:text-white"
              >Password</label
            >
            <div class="relative">
              <div
                class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
              >
                <svg
                  class="m-1 w-6 h-6 3xl:w-8 3xl:h-8 4xl:w-10 4xl:h-10 text-gray-400 dark:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 10V7a4 4 0 1 1 8 0v3h1a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h1Zm2-3a2 2 0 1 1 4 0v3h-4V7Zm2 6a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
              <input
                [type]="showPassword ? 'text' : 'password'"
                name="password"
                id="password"
                [formControlName]="'password'"
                class="h-12 3xl:h-14 4xl:h-16 mt-0 3xl:mt-3 4xl:mt-5 text-sm 3xl:text-[1.1em] 4xl:text-[1.3em] pl-13 3xl:pl-15 4xl:pl-17 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-gray-600 focus:border-gray-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-gray-500 dark:focus:border-gray-500 read-only:cursor-not-allowed"
                required=""
                [readOnly]="this.company ? true : false"
              />

              <!-- Bottone per togglare la visibilità della password -->
              <button
                type="button"
                (click)="togglePassword()"
                class="absolute inset-y-0 right-0 flex items-center z-20 px-3 cursor-pointer text-gray-400 rounded-e-md focus:outline-hidden focus:text-blue-600 dark:text-neutral-600 dark:focus:text-blue-500"
              >
                <!-- Occhio aperto -->
                <svg
                  *ngIf="showPassword"
                  class="w-6 h-6 3xl:w-8 3xl:h-8 4xl:w-10 4xl:h-10 text-gray-400 dark:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    stroke-width="2"
                    d="M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z"
                  />
                  <path
                    stroke="currentColor"
                    stroke-width="2"
                    d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                  />
                </svg>

                <!-- Occhio chiuso -->
                <svg
                  *ngIf="!showPassword"
                  class="w-6 h-6 3xl:w-8 3xl:h-8 4xl:w-10 4xl:h-10 text-gray-400 dark:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3.933 13.909A4.357 4.357 0 0 1 3 12c0-1 4-6 9-6m7.6 3.8A5.068 5.068 0 0 1 21 12c0 1-3 6-9 6-.314 0-.62-.014-.918-.04M5 19 19 5m-4 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                  />
                </svg>
              </button>
            </div>
            <div class="w-auto" *ngIf="isInvalidCredentials">
              <span
                class="text-red-600 relative top-[1px] 3xl:top-[4px] 4xl:top-[8px] left-1 text-[0.7em] 3xl:text-[0.9em] 4xl:text-[1.1em]"
                >{{ errorMessage }}</span
              >
            </div>
          </div>

          <div class="flex items-center justify-between">
            <span
              role="button"
              (click)="resetPassword()"
              class="text-[0.85em] 3xl:text-[1em] 4xl:text-[1.15em] font-medium text-[#4299e1] hover:text-[#4299e1a0] dark:text-primary-500 cursor-pointer"
              >Password dimenticata?</span
            >
          </div>
          <button
            type="submit"
            class="w-full cursor-pointer mt-0 3xl:mt-6 h-[52px] 3xl:h-[66px] 4xl:h-[80px] text-[1.05em] 3xl:text-[1.25em] 4xl:text-[1.4em] text-white bg-dimot-1 hover:bg-[#4f5984] font-medium rounded-lg px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 transition-all duration-300 ease-in-out disabled:cursor-not-allowed"
            [disabled]="this.company ? true : false"
          >
            <span *ngIf="!isLoading"> Continua</span>

            <span *ngIf="isLoading">
              <svg
                aria-hidden="true"
                role="status"
                class="inline w-6 h-6 me-3 text-white animate-spin"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="#E5E7EB"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentColor"
                />
              </svg>
              Accesso in corso...
            </span>
          </button>
        </form>
        <!-- Divider for alternative login methods -->
        <div *ngIf="renderSSO">
          <div class="flex items-center justify-center my-6">
            <div class="flex-grow h-px bg-gray-300"></div>
            <span
              class="mx-4 text-gray-500 text-[0.85em] 3xl:text-[1em] 4xl:text-[1.15em]"
              >oppure</span
            >
            <div class="flex-grow h-px bg-gray-300"></div>
          </div>

          <div class="flex justify-center">
            <button
              (click)="loginWithMicrosoft()"
              class="flex items-center gap-2 px-5 py-3 h-[47px] 3xl:h-[61px] 4xl:h-[75px] border border-gray-300 rounded-md hover:bg-gray-100 transition cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
              [disabled]="isSSOLoading"
            >
              <img
                src="assets/img/Icons/Microsoft_logo.svg"
                alt="Microsoft"
                class="w-5 h-5 3xl:w-6 3xl:h-6 4xl:w-7 4xl:h-7"
              />
              <span
                class="text-[0.88em] 3xl:text-[1.03em] 4xl:text-[1.18em] font-extralight text-[#6B7280]"
                >Continua con Microsoft</span
              >
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div *ngIf="isPasswordResetOpen">
  <app-password-reset
    (emitterResetPasswordOpen)="handlePasswordResetStatus($event)"
  ></app-password-reset>
</div>
<div *ngIf="isMfaVerificationOpen">
  <app-mfa-verification
    [username]="username"
    [session]="session"
    (emitterOpenTerms)="handleOpenTerms($event)"
    (emitterPendingLoginData)="handlePendingLoginData($event)"
  ></app-mfa-verification>
</div>
<div *ngIf="isForcePwdResetOpen">
  <app-force-password-reset
    [username]="username"
    [session]="session"
    (emitterOpenTerms)="handleOpenTerms($event)"
    (emitterPendingLoginData)="handlePendingLoginData($event)"
  >
  </app-force-password-reset>
</div>
<app-terms-and-conditions
  *ngIf="isTermsOpen"
  (emitterOpenTerms)="handleOpenTerms($event)"
  (termsAccepted)="handleTermsAccepted($event)"
></app-terms-and-conditions>
